var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('v-flex',{staticClass:"database-content"},[(_vm.content.title)?_c('div',{staticClass:"headline mb-4"},[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_c('v-flex',{staticClass:"light-font",domProps:{"innerHTML":_vm._s(_vm.content.text)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }